"use client"

import { useId, type ReactNode } from "react"
import { Switch as UiSwitch } from "@/components/ui/switch"
import { Label as UiLabel } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export type SwitchProps = {
  checked?: boolean
  defaultChecked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  label?: ReactNode
  description?: ReactNode
  id?: string
  name?: string
  className?: string
}

export function Switch({
  checked,
  defaultChecked,
  onCheckedChange,
  disabled,
  label,
  description,
  id,
  name,
  className,
}: SwitchProps) {
  const reactId = useId()
  const switchId = id ?? `compass-switch-${reactId}`

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <UiSwitch
        id={switchId}
        {...(checked !== undefined ? { checked } : {})}
        {...(defaultChecked !== undefined ? { defaultChecked } : {})}
        {...(onCheckedChange ? { onCheckedChange } : {})}
        {...(disabled !== undefined ? { disabled } : {})}
        {...(name !== undefined ? { name } : {})}
      />
      {label ? (
        <div className="flex flex-col">
          <UiLabel htmlFor={switchId} className="text-sm text-markv-text-700">
            {label}
          </UiLabel>
          {description ? (
            <span className="text-xs text-markv-text-400">{description}</span>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
